import React from "react";
import { useSelector } from "react-redux";
import { Form, Field } from "formik";
import { makeStyles } from "@material-ui/styles";
import TextInput from "../../Common/textInput";
import { getVisible, getRequired } from "./util";

const useStyles = makeStyles({
  form: {
    marginTop: "16px",
  },
  row: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridGap: "16px",
    "@media (max-width: 667px)": {
      gridTemplateColumns: "1fr",
    },
  },
});

const ResponsibleForm = () => {
  const classes = useStyles();
  const { config, language } = useSelector((state) => ({
    config: state.config,
    language: state.language,
  }));
  const { visibleFields, requiredFields } =
    config.fieldInfo.registerParticipant;
  const show = (field) => getVisible(visibleFields, field);
  const required = (field) => getRequired(requiredFields, field);

  return (
    <Form className={classes.form}>
      <div className={classes.row}>
        <Field
          name="firstName"
          label={language.form.FirstName_Label}
          placeholder={language.form.FirstName_Placeholder}
          required={true}
          component={TextInput}
        />
        <Field
          name="lastName"
          label={language.form.LastName_Label}
          placeholder={language.form.LastName_Placeholder}
          required={true}
          component={TextInput}
        />
      </div>
      <div className={classes.row}>
        {show("civicRegistrationNumber") && (
          <Field
            name="civicRegistrationNumber"
            label={language.form.CivicRegistration_Label}
            placeholder={language.form.CivicRegistration_Placeholder}
            required={required("civicRegistrationNumber")}
            component={TextInput}
          />
        )}
      </div>
    </Form>
  );
};

export default ResponsibleForm;
